// One signal colour per service family, used identically on the finder result,
// the catalogue, the course page, the admin screens and the studio. The values
// are CSS variables from styles/tokens.css, so they switch with light and dark.
//
//   AI blue, B-BBEE purple, ESG green, Finance amber,
//   Skills / Employment Equity / HR orange.
//
// Categories with no service of their own (Microsoft 365, Cybersecurity,
// Developer Tools, Compliance) are technology courses and use AI blue.
const SERVICE_BY_CATEGORY = {
  'B-BBEE': 'bbbee',
  'AI': 'ai',
  'AI Tools': 'ai',
  'AI & Compliance': 'ai',
  'Compliance': 'ai',
  'Microsoft 365': 'ai',
  'Developer Tools': 'ai',
  'Cybersecurity': 'ai',
  'ESG': 'esg',
  'Finance': 'finance',
  'Employment Equity': 'skills',
  'Skills Development': 'skills',
  'HR': 'skills',
  'Work Readiness': 'skills',
};

export const SERVICES = ['ai', 'bbbee', 'esg', 'finance', 'skills'];

export const SERVICE_LABELS = {
  ai: 'AI',
  bbbee: 'B-BBEE',
  esg: 'ESG',
  finance: 'Finance',
  skills: 'Skills and Employment Equity',
};

export function serviceOf(category) {
  return SERVICE_BY_CATEGORY[category] || null;
}

// Text and icon colour (meets AA on the surface colours).
export function serviceColour(service) {
  return service ? `var(--ok-${service})` : 'var(--ok-primary)';
}

// Solid fill for bars and dots. Finance and Skills have a brighter fill shade.
export function serviceFill(service) {
  return service === 'finance' || service === 'skills' ? `var(--ok-${service}-fill)` : serviceColour(service);
}

export function serviceTint(service) {
  return service ? `var(--ok-${service}-tint)` : 'var(--ok-primary-tint)';
}

export const categoryColour = category => serviceColour(serviceOf(category));
export const categoryFill = category => serviceFill(serviceOf(category));
export const categoryTint = category => serviceTint(serviceOf(category));

// Keeps the old name for callers that still import the map.
export const CATEGORY_COLOURS = Object.fromEntries(
  Object.keys(SERVICE_BY_CATEGORY).map(category => [category, categoryColour(category)])
);

export const OKIRU_ACCENT = 'var(--ok-primary)';

// A see-through version of any colour, for badges and soft backgrounds.
// Works with CSS variables, unlike appending a hex alpha such as '15'.
export function withAlpha(colour, percent) {
  return `color-mix(in srgb, ${colour} ${percent}%, transparent)`;
}
